import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-466a7e43")

_pushScopeId("data-v-466a7e43")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "tips" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ProperAllTextResidentOrStaffDeleteAll,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    width: "600px",
    onSubmit: _ctx.submit
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextDeleteAllTips), 1),
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formEle"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { prop: "Password" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Password = $event)),
                  "auto-complete": "off",
                  type: "password"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
})